import { GraphicElement } from '../../entities/Drawable/GraphicElement';
import { Engine } from '../../core/Engine';
import { CreateCommand } from '../Commands';
import { Group } from '../../entities/Drawable/Group';
import { BackPattern } from '../../entities/Drawable/BackPattern';
import { Image } from '../../entities/Drawable/Image';

export class CreateCommandHandler {
    engine: Engine;

    constructor(engine: Engine) {
        this.engine = engine;
    }

    handle(command: CreateCommand): void {
        const elToCreate: GraphicElement = this.engine.create(command.type, command.content, command.pos);
        let obj: GraphicElement | undefined;
        if (elToCreate instanceof Group || elToCreate.uuid === 'graduation') {
            obj = this.engine.content.find((o) => o.type === command.type);
        }
        if (obj) {
            // override existing object
            const i = this.engine.content.indexOf(obj);
            this.engine.content[i] = elToCreate;
        } else if (elToCreate instanceof BackPattern) {
            this.engine.content.unshift(elToCreate);
        } else {
            this.engine.content.push(elToCreate);
        }

        const graduation = this.engine.content.find((o) => o.type === 'Graduation');
        if (graduation) {
            const index = this.engine.content.indexOf(graduation);
            this.engine.content.splice(index, 1);
            this.engine.content.push(graduation);
        }

        if (elToCreate instanceof Image && command.clipPath) {
            elToCreate.clipPath = command.clipPath;
        }

        if (elToCreate instanceof Group && command.colorGroups) {
            elToCreate.colorGroups = command.colorGroups;
        }

        elToCreate.transform.rotate(command.rotation.angle);
        elToCreate.originSize = command.size;
        elToCreate.transform.resize(command.scale, true);
        elToCreate.canBeUnlocked = command.canBeUnlocked;
        elToCreate.options = command.options;
        elToCreate.isDuplicated = command.isDuplicated;
        this.engine.selectedElement = elToCreate;
        this.engine.canvas.renderAll();
    }
}
